import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-billet-log-dialog',
  template: `
    <div class="p-dialog-content">
      <p-table [value]="logs" styleClass="p-datatable-sm" [paginator]="true" [rows]="10">
        <ng-template pTemplate="header">
          <tr>
            <th>Data Alteração</th>
            <th>Identifier</th>
            <th>Cliente ID</th>
            <th>Fatura ID</th>
            <th>Boleto ID</th>
            <th>Status</th>
            <th>Responsável</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-log>
          <tr>
            <td>{{log.changeDate | date:'dd/MM/yyyy HH:mm'}}</td>
            <td>{{log.identifier}}</td>
            <td>{{log.customerId}}</td>
            <td>{{log.invoiceId}}</td>
            <td>{{log.billetId}}</td>
            <td>{{log.status}}</td>
            <td>{{log.responsible}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9" class="text-center p-3">
              <i class="pi pi-info-circle"></i>
              Nenhum log encontrado para este boleto.
            </td>
          </tr>
        </ng-template>
      </p-table>
      
      
    </div>
  `,
  styles: [`
    :host {
      display: block;
      max-height: 50vh;
      overflow-y: auto;
    }
    
    .p-dialog-content {
      padding: 0;
    }
    
    .p-dialog-footer {
      padding: 1rem;
      border-top: 1px solid #e9ecef;
    }
  `]
})
export class BilletLogDialogComponent {
  logs: any[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    if (config.data && config.data.logs) {
      this.logs = config.data.logs;
    }
  }
}